import { gql } from "apollo-angular";

export interface CertDdosChartSubscriptionList {
  surfCertList: {
    page: CertDdosChartSubscription[];
  };
}

export interface CertDdosChartSubscription {
  customerDescription: string;
  description: string;
  productType: string;
  status: string;
  subscriptionId: string;
  surfcertFilterEnabled: boolean;
}

export const SURF_CERT_DDOS_QUERY = gql`
  query SurfCertDdosItems($customer: UUID!) {
    surfCertList(searchFilter: { accessCustomerId: $customer }) {
      page {
        customerDescription
        description
        productType
        status
        subscriptionId
        surfcertFilterEnabled
      }
    }
  }
`;
